var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.is_show)?_c('div',{staticClass:"text"},[_vm._v(" 请点击右上角菜单，选择使用浏览器打开"),_c('br'),_vm._v(" (如已支付请返回) ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }